module.exports = __webpack_public_path__ + "img/application_screen.49f09051.png";